import { filterControlsGerman } from "./filterControls";
import { askGerman } from "./ask";
import { german as settingsGerman } from "./settings/german";
import type { ClankTranslation } from "./shared";
import { german as tourGerman } from "./tour/german";
import { german as watchlistGerman } from "./watchlist/german";

export const german = {
  process_details: "Prozessdetails",
  session_details: "Sitzungsdetails",
  interactive_chat: "Interaktiver Chat",
  page_error: "Fehler",
  askPanel: askGerman,
  filterControls: filterControlsGerman,
  Settings: "Einstellungen",
  web_service_limited_functionality_banner:
    "Dieser Webdienst enthält nicht alle Platonic-Funktionen. Um <strong>deine</strong> Arbeit abzubilden, verwende die Platonic-Desktop-App.",
  static_demo_limited_functionality_banner:
    "Diese Demo ist eine vereinfachte Darstellung unseres Produkts. Keine Funktion hier ist dauerhaft, und alle Daten sind synthetisch. Kontaktiere uns für das echte Produkt.",
  download_platonic_desktop: "Platonic Desktop herunterladen",
  downloads_page: "Downloads",
  downloads_page_description:
    "Lade das Installationsprogramm der Platonic-Desktop-App für dein Betriebssystem herunter.",
  downloads_registered_users_only_title: "Downloads sind registrierten Benutzern vorbehalten",
  downloads_registered_users_only_message:
    "Der Platonic-Desktop-Installer ist nach dem Onboarding verfügbar. Kontaktiere uns, und wir helfen dir, den Zugang für dein Unternehmen zu aktivieren.",
  contact_us_for_onboarding: "Kontakt aufnehmen",
  downloads_load_failed: "Downloads konnten nicht geladen werden",
  no_downloads_available_for_os: "Für {{os}} sind derzeit keine Downloads verfügbar.",
  operating_systems: "Betriebssysteme",
  windows: "Windows",
  macos: "macOS",
  linux: "Linux",
  released: "Veröffentlicht",
  download: "Herunterladen",
  executive_dashboard: "Verwaltung",
  processes: "Prozesse",
  recordings: "Sitzungen",
  close: "Schließen",
  cancel: "Abbrechen",
  or: "oder",
  submit: "Senden",
  save: "Speichern",
  loading: "Laden",
  loading_ellipsis: "Laden…",
  generating_graph: "Graph wird erstellt…",
  regenerating_graph: "Graph wird neu erstellt…",
  graph_layout_failed:
    "Der Graph konnte nicht angeordnet werden. Lade die Seite neu, um es erneut zu versuchen.",
  loading_app: "App wird geladen...",
  user: "Benutzer",
  source: "Quelle",
  what_platonic_records: "Was Platonic erfasst",
  capture_privacy_summary:
    "Platonic erfasst regelmäßige Screenshots, Klick- und Scroll-Ereignisse, Tastaturkurzbefehle und Sondertasten (wie Enter, Tab oder Cmd+C) sowie den Titel deines aktiven Fensters, um deine Workflow-Schritte zu verstehen.",
  no_typed_content: "Keine getippten Inhalte",
  no_typed_content_detail: "Platonic erfasst nicht den tatsächlichen Text, den du eingibst.",
  no_continuous_recording: "Keine kontinuierliche Bildschirmaufzeichnung",
  no_continuous_recording_detail:
    "Platonic speichert einzelne Screenshots, kein Video deines Bildschirms.",
  no_audio_or_microphone: "Kein Audio oder Mikrofon",
  no_camera_access: "Kein Kamerazugriff",
  language: "Sprache",
  context: "Kontext",
  execution_mode: "Ausführungsmodus",
  start_recording: "Meine Arbeit abbilden",
  recording: "Mapping",
  paused: "Pausiert",
  stopping_recording: "Mapping wird beendet",
  syncing: "Synchronisiere...",
  unable_to_load_recordings: "Sitzungen konnten nicht geladen werden",
  recordings_update_failed:
    "Sitzungen konnten nicht aktualisiert werden; die Liste ist möglicherweise veraltet.",
  unable_to_check_updates: "Updates konnten nicht geprüft werden",
  api_version_mismatch_title: "Platonic-Versionen stimmen nicht überein",
  api_version_mismatch_remote_newer: "neuere",
  api_version_mismatch_remote_older: "ältere",
  api_version_mismatch_remote_different: "andere",
  api_version_mismatch_message:
    "Der Remote-Server hat eine {{relation}} Version als diese App (Server {{remoteVersion}}, lokal {{localVersion}}). Der automatische Update-Download läuft; bis zur Installation des Updates können einige Funktionen fehlschlagen.",
  update_failed: "Update fehlgeschlagen",
  analysis_failed: "Analyse fehlgeschlagen",
  run_failed: "Ausführung fehlgeschlagen",
  failed_to_load_details_for_one_recording: "Details für 1 Sitzung konnten nicht geladen werden.",
  recording_permissions: "Aufnahmeberechtigungen",
  recording_permissions_ready_description: "Alle Berechtigungen für Aufnahmen sind erteilt.",
  recording_permissions_modal_description:
    "Prüfe die Systemberechtigungen, die Platonic vor der Aufnahme benötigt.",
  recording_permissions_recommended_description:
    "Aufnahmen funktionieren, aber mit den empfohlenen Einstellungen werden sie detaillierter.",
  recording_permissions_restart_title: "Platonic muss beendet und neu geöffnet werden",
  recording_permissions_restart_app:
    "Nachdem du Bedienungshilfen oder andere Aufnahmeberechtigungen geändert hast, beende Platonic vollständig und öffne es erneut.",
  recording_permissions_load_failed: "Aufnahmeberechtigungen konnten nicht geladen werden",
  recording_permissions_check_again: "Erneut prüfen",
  permission_status_granted: "Erteilt",
  permission_required_for_recording: "Berechtigung nötig",
  review_recording_permissions: "Berechtigungen prüfen",
  set_recording_permissions: "Aufnahmeberechtigungen einrichten",
  request_permission: "Anfordern",
  open_system_settings: "Einstellungen",
  turn_on_permission: "Einschalten",
  accessibility_permission: "Bedienungshilfen",
  input_monitoring_permission: "Eingabeüberwachung",
  input_monitoring_blocked_description:
    "Die Eingabeerfassung wird von macOS blockiert. Das passiert meistens, wenn Platonic in der Eingabeüberwachung ausdrücklich abgelehnt wurde. Öffne Systemeinstellungen > Datenschutz & Sicherheit > Eingabeüberwachung und entferne oder aktiviere Platonic, dann starte Platonic neu.",
  screen_and_system_audio_recording_permission: "Bildschirm & Systemaudio",
  desktop_accessibility_permission: "Desktop-Barrierefreiheit",
  desktop_accessibility_description:
    "Ermöglicht Platonic, die Namen der verwendeten Schaltflächen und Felder aufzuzeichnen. Apps, die beim Einschalten bereits geöffnet waren, müssen neu gestartet werden, um erfasst zu werden.",
  settings: settingsGerman,
  finalizing_recording: "Aufnahme wird verarbeitet",
  redacting_screenshots: "Verbleibende Screenshots werden vor dem Hochladen geschwärzt",
  saved: "gespart",
  lost: "verloren",
  latest: "Neueste",
  step: "Schritt",
  steps: "Schritte",
  n_steps: "{{count}} Schritte",
  n_steps_one: "{{count}} Schritt",
  instances: "Fälle",
  instances_unit: "Fälle",
  all_instances: "Alle Fälle",
  all_n_instances: "Alle {{count}} Fälle",
  all_n_instances_one: "{{count}} Fall",
  n_recordings: "{{count}} Sitzungen",
  n_recordings_one: "{{count}} Sitzung",
  selected_n_of_total_instances: '{{count}} von $t(n_instances, {"count": {{total}} }) ausgewählt',
  selected_n_of_total_instances_one:
    '{{count}} von $t(n_instances, {"count": {{total}} }) ausgewählt',
  filter_action: "Filtern",
  filtering_instances: "Passende Fälle werden ausgewählt...",
  filter_failed: "Der Fallfilter ist fehlgeschlagen. Bitte erneut versuchen.",
  describe_instances_you_want: "Fälle in natürlicher Sprache filtern...",
  no_instances_match_condition: "Nichts entsprach dieser Bedingung.",
  filter_instances: "Fälle filtern",
  no_matching_steps: "Keine passenden Schritte.",
  remove_filter: "Filter {{label}} entfernen",
  scope_filter_query: "Beschreibung",
  scope_filter_user: "Benutzer",
  scope_filter_date: "Datum",
  scope_filter_node: "Schritt",
  scope_date_from: "ab {{date}}",
  scope_date_until: "bis {{date}}",
  scope_through_node: "über {{name}}",
  scope_hand_picked: "manuell angepasst",
  last_n_days: "Letzte {{count}} Tage",
  last_n_days_one: "Letzter {{count}} Tag",
  scope_date_any: "Datum wählen",
  scope_date_dots_legend: "An diesem Tag gestartete Fälle dieses Prozesses",
  scope_filter_done: "Fertig",
  scope_filter_apply: "Anwenden",
  previous_month: "Vorheriger Monat",
  next_month: "Nächster Monat",
  no_instances_match_scope: "Kein Fall entspricht dieser Auswahl.",
  scope_criteria_conflict: "{{criteria}} können nicht beide zutreffen.",
  scope_criteria_join: " und ",
  scope_matching_and_selected: "{{matched}} passend · {{included}} ausgewählt",
  scope_matching_all_selected: "{{matched}} passend · alle ausgewählt",
  scope_all_instances: "Alle {{matched}} Fälle",
  scope_selected_of_all: "{{included}} von {{matched}} Fällen ausgewählt",
  close_filter_editor: "Filter schließen",
  scope_criterion_rules_out_everything: "{{criteria}} schließt jeden Fall aus.",
  scope_label: "Auswahl",
  expand_instances: "Fälle erweitern für",
  collapse_instances: "Fälle einklappen für",
  succeeded: "Erfolgreich",
  failed: "Fehlgeschlagen",
  running: "Läuft",
  pending: "Ausstehend",
  cancelled: "Abgebrochen",
  process: "Prozess",
  analyze_now: "Analysieren",
  analyzing_ellipsis: "Analysiere...",
  no_recordings_available: "Keine Sitzungen verfügbar.",
  loading_recordings: "Sitzungen werden geladen...",
  authentication_required: "Authentifizierung erforderlich",
  browser_login_wait_title: "Ein Browser-Tab wurde geöffnet",
  browser_login_wait_message:
    "Setze dort die Anmeldung fort. Dieses Fenster fährt automatisch fort, sobald die Anmeldung abgeschlossen ist.",
  browser_login_waiting_status: "Warte auf Anmeldung...",
  browser_login_complete_status: "Anmeldung abgeschlossen. Zurück zu Clank...",
  browser_login_done_title: "Anmeldung abgeschlossen",
  browser_login_done_message: "Du kannst dieses Fenster schließen und zur App zurückkehren.",
  csrf_validation_failed_missing_header: "CSRF-Validierung fehlgeschlagen: Token fehlt.",
  csrf_validation_failed_invalid_header: "CSRF-Validierung fehlgeschlagen: Token ungueltig.",
  login_again: "Erneut anmelden",
  login_again_message:
    "Eine Remote-Anfrage an den Server hat den Fehler 'unauthenticated' zurückgegeben. Es wird empfohlen, sich erneut anzumelden.",
  recent_recordings: "Neueste Sitzungen",
  recordings_click_to_view_full_analysis:
    "{{count}} Sitzungen erfasst · Klicken, um die vollständige Analyse anzuzeigen",
  recordings_click_to_view_full_analysis_one:
    "{{count}} Sitzung erfasst · Klicken, um die vollständige Analyse anzuzeigen",
  uploading_recording_data: "Sitzungsdaten werden hochgeladen...",
  syncing_recording: "Sitzung wird synchronisiert",
  sync_failed: "Synchronisierung fehlgeschlagen",
  no_analyzed_recordings_available_yet: "Noch keine analysierten Sitzungen verfügbar.",
  recording_archived: "Archiviert",
  recording_active: "Aktiv",
  current_user: "Du",
  recording_filter_scope: "Anzeigen",
  recording_filter_all: "Alle",
  rename_recording: "Umbenennen",
  archive_recording: "Archivieren",
  unarchive_recording: "Wiederherstellen",
  archive_recording_tooltip:
    "Archivierte Sitzungen bleiben unter Archiviert oder Alle verfügbar, werden aber aus der Übersicht und den Prozesskennzahlen ausgeschlossen.",
  unarchive_recording_tooltip:
    "Diese Sitzung wieder in die aktive Liste, Übersicht und Prozesskennzahlen aufnehmen.",
  recording_archive_update_failed: "Archivstatus konnte nicht aktualisiert werden",
  archived_recordings_match_filters_one: "{{count}} archivierte Sitzung entspricht deinen Filtern.",
  archived_recordings_match_filters: "{{count}} archivierte Sitzungen entsprechen deinen Filtern.",
  show_archived_recordings: "Archivierte anzeigen",
  select_recording: "Sitzung auswählen",
  select_all_recordings_on_page: "Alle auf dieser Seite auswählen",
  recordings_selected_one: "{{count}} Sitzung ausgewählt",
  recordings_selected: "{{count}} Sitzungen ausgewählt",
  clear_selection: "Auswahl aufheben",
  bulk_actions: "Massenaktionen",
  archive_selected_recordings: "Ausgewählte archivieren",
  unarchive_selected_recordings: "Ausgewählte wiederherstellen",
  delete_selected_recordings: "Ausgewählte löschen",
  bulk_archive_recordings_title_one: "{{count}} Sitzung archivieren?",
  bulk_archive_recordings_title: "{{count}} Sitzungen archivieren?",
  bulk_unarchive_recordings_title_one: "{{count}} Sitzung wiederherstellen?",
  bulk_unarchive_recordings_title: "{{count}} Sitzungen wiederherstellen?",
  bulk_delete_recordings_title_one: "{{count}} Sitzung löschen?",
  bulk_delete_recordings_title: "{{count}} Sitzungen löschen?",
  bulk_archive_recordings_message:
    "Diese Sitzungen bleiben unter Archiviert oder Alle verfügbar, werden aber aus der Übersicht und den Prozesskennzahlen ausgeschlossen.",
  bulk_unarchive_recordings_message:
    "Diese Sitzungen werden wieder in die aktive Liste, Übersicht und Prozesskennzahlen aufgenommen.",
  bulk_delete_recordings_message:
    "Die folgenden Sitzungen werden aus dem Remote-Speicher und aus Platonic entfernt. Dies kann nicht rückgängig gemacht werden.",
  bulk_delete_analyzing_notice_one:
    "{{count}} Sitzung wird noch analysiert und wird nicht gelöscht. Stoppe zuerst die Analyse, wenn du sie löschen möchtest.",
  bulk_delete_analyzing_notice:
    "{{count}} Sitzungen werden noch analysiert und werden nicht gelöscht. Stoppe zuerst die Analysen, wenn du sie löschen möchtest.",
  bulk_recording_update_failed_one:
    "{{count}} Sitzung konnte nicht aktualisiert werden. Sie bleibt ausgewählt, damit du es erneut versuchen kannst.",
  bulk_recording_update_failed:
    "{{count}} Sitzungen konnten nicht aktualisiert werden. Sie bleiben ausgewählt, damit du es erneut versuchen kannst.",
  bulk_recording_delete_failed_one:
    "{{count}} Sitzung konnte nicht gelöscht werden. Sie bleibt ausgewählt, damit du es erneut versuchen kannst.",
  bulk_recording_delete_failed:
    "{{count}} Sitzungen konnten nicht gelöscht werden. Sie bleiben ausgewählt, damit du es erneut versuchen kannst.",
  delete_recording: "Sitzung löschen",
  delete_recording_title: "Sitzung löschen?",
  delete_recording_message: "Entfernt diese Sitzung. Dies kann nicht rückgängig gemacht werden.",
  delete_recording_message_synced:
    "Entfernt diese Sitzung aus dem Remote-Speicher und aus Platonic. Dies kann nicht rückgängig gemacht werden.",
  delete_recording_message_local:
    "Entfernt diese Sitzung von diesem Computer. Dies kann nicht rückgängig gemacht werden.",
  acknowledge_delete_recording: "Ich verstehe, dass dies nicht rückgängig gemacht werden kann.",
  confirm_delete_recording: "Dauerhaft löschen",
  recording_delete_failed: "Sitzung konnte nicht gelöscht werden",
  recording_import: "Sitzungsimport",
  recording_import_card_description:
    "Eine Sitzungsanalyse aus einem validierten JSON-Ergebnis erstellen oder ersetzen.",
  import_recording_analysis: "Sitzungsanalyse importieren",
  edit_recording_analysis: "Sitzungsanalyse bearbeiten",
  recording_import_description:
    "Füge ein vollständiges Analyseergebnis als JSON ein. Platonic validiert es und berechnet die Sitzungsdaten.",
  failed_to_load_recording_import_data: "Importdaten der Sitzung konnten nicht geladen werden",
  loading_recording_import_data: "Importdaten der Sitzung werden geladen...",
  failed_to_save_recording_analysis: "Sitzungsanalyse konnte nicht gespeichert werden",
  you_do_not_have_permission_to_import_recordings:
    "Du hast keine Berechtigung, Sitzungsanalysen zu importieren.",
  select_user_for_recording_import: "Wähle den Benutzer aus, zu dem diese Sitzung gehört.",
  recording_name: "Sitzungsname",
  include_imported_recording_in_processes: "Diese Sitzung in die Prozessgenerierung aufnehmen",
  recording_import_no_existing_analysis:
    "Diese Sitzung hat noch kein abgeschlossenes Analyseergebnis. Füge das vollständige Ersatz-JSON ein.",
  analysis_result_json: "Analyseergebnis JSON",
  analysis_result_json_help:
    "Füge das vollständige Analyseergebnis-Objekt ein. Es muss dem Backend-AnalyticsData-Schema entsprechen.",
  save_recording_analysis: "Sitzungsanalyse speichern",
  app_menu: "Menü",
  recording_deletion_started:
    "Löschung gestartet. Dies ist ein langer Vorgang; komm später zurück, um den Stand zu prüfen.",
  recording_deletion_already_in_progress:
    "Eine Löschung läuft bereits. Komm später zurück, um den Abschluss zu prüfen.",
  expand_sidebar: "Seitenleiste erweitern",
  go_back: "Zurück",
  go_forward: "Vorwärts",
  collapse_sidebar: "Seitenleiste einklappen",
  resize_sidebar: "Zum Ändern der Größe ziehen · Doppelklick zum Zurücksetzen",
  no_data: "Keine Daten",
  end_stream: "Stream beenden",
  unknown: "unbekannt",
  ended: "Beendet",
  refuse: "Ablehnen",
  initial_app_load_failed: "Fehler beim ersten Laden der Anwendung",
  retry: "Erneut versuchen",
  created: "Erstellt",
  started: "Gestartet",
  manual_interventions: "Manuelle Eingriffe",
  trigger_entity: "Auslösendes Objekt",
  extra_context: "Zusätzlicher Kontext",
  group: "Gruppe",
  thinking: "Denke nach...",
  overview: "Übersicht",
  timeline: "Zeitachse",
  missing_analytics_identifier_in_url: "Analysekennung in der URL fehlt.",
  unable_to_load_recording_data: "Sitzungsdaten konnten nicht geladen werden",
  loading_recording: "Sitzung wird geladen...",
  recording_not_found_title: "Sitzung nicht gefunden",
  recording_not_found_message:
    "Diese Sitzung existiert nicht oder du hast keine Berechtigung, sie anzusehen.",
  back_to_recordings: "Zurück zu den Sitzungen",
  analyzing_recording: "Sitzung wird analysiert...",
  stop_analysis: "Analyse stoppen",
  stopping_analysis: "Stoppt...",
  failed_to_stop_analysis: "Analyse konnte nicht gestoppt werden",
  something_went_wrong_you_can_retry_the_analysis:
    "Etwas ist schiefgelaufen. Du kannst die Analyse erneut versuchen.",
  this_recording_has_not_been_analyzed_yet: "Diese Sitzung wurde noch nicht analysiert.",
  analysis_cancelled_page_message: "Die Analyse wurde abgebrochen. Du kannst sie erneut starten.",
  recording_too_short: "Zu kurz",
  analysis_runs: "Analyselaeufe",
  analysis_run_pill_label: "Analyselauf",
  analysis_run_latest: "neuester",
  rerun_analysis: "Analyse erneut ausfuehren",
  rerunning_ellipsis: "Wird erneut analysiert...",
  rerun_failed: "Erneute Analyse fehlgeschlagen",
  rerun_progress_title: "Erneute Analyse laeuft",
  rerun_progress_message:
    "Die Sitzung zeigt weiterhin das vorherige Ergebnis, bis dieser Lauf fertig ist.",
  rerun_progress_waiting: "Warten auf den Fortschritt der Analyse...",
  view_rerun_progress: "Fortschritt der erneuten Analyse anzeigen",
  rename_analysis_run: "Lauf umbenennen",
  analysis_run_rename_message:
    "Benenne diesen Lauf, um ihn von den anderen Laeufen der Sitzung zu unterscheiden.",
  analysis_run_name_placeholder: "Diesen Lauf benennen",
  analysis_run_rename_failed: "Der Analyselauf konnte nicht umbenannt werden",
  delete_analysis_run: "Lauf loeschen",
  delete_analysis_run_message:
    "Es wird nur dieser Analyselauf geloescht. Die Sitzung und ihre anderen Laeufe bleiben erhalten.",
  delete_last_analysis_run_message:
    "Dies ist die einzige Analyse der Sitzung. Die Sitzung selbst bleibt erhalten und gilt als nicht analysiert, bis du die Analyse erneut ausfuehrst.",
  analysis_run_delete_failed: "Der Analyselauf konnte nicht geloescht werden",
  compare_analysis_runs: "Laeufe vergleichen",
  compare_with_run_unavailable: "Ein fehlgeschlagener Lauf hat kein Ergebnis zum Vergleichen",
  compare_run_on_other_band: "Wird bereits im anderen Band gezeigt",
  compare_pick_two_runs: "Zwei Laeufe zum Vergleichen auswaehlen",
  compare_run_band: "Lauf {{side}}: {{name}}",
  change_run: "Lauf wechseln",
  compare_run_load_failed: "Der verglichene Lauf konnte nicht geladen werden",
  rerun_from_run: "Ab diesem Lauf erneut ausfuehren",
  rerun_from_run_named: "Ab Lauf „{{name}}“ erneut ausfuehren",
  rerun_from_run_unavailable:
    "Dieser Lauf hat keine Artefakte behalten, auf denen aufgesetzt werden kann",
  rerun_from_run_message: "Die Stufen vor der gewaehlten werden aus diesem Lauf kopiert.",
  analysis_rerun_failed: "Die erneute Analyse konnte nicht gestartet werden",
  rerun_selected_recordings: "Analyse fuer Auswahl erneut ausfuehren",
  rerun_recordings_title: "Analyse erneut ausfuehren",
  rerun_recordings_message:
    "Jede ausgewaehlte Sitzung wird erneut analysiert. Die aktuellen Ergebnisse bleiben sichtbar, bis ein Lauf fertig ist.",
  recording_too_short_page_message:
    "Wir brauchen mindestens 60 Sekunden Aktivität, um eine Sitzung analysieren zu können.",
  retry_analysis: "Analyse erneut versuchen",
  view_analysis: "Analyse ansehen",
  analyze: "Analysieren",
  no_recording_data_available: "Keine Sitzungsdaten verfügbar.",
  recording_session: "Arbeitssitzung",
  local_recording_unavailable:
    "Das Abbilden deiner Arbeit ist nur in der Platonic-Desktop-App verfügbar.",
  activity_feed: "Aktivitäts-Feed",
  live_activity_captured_during_recording: "Während der Sitzung erfasste Live-Aktivität.",
  no_feed_events_yet: "Noch keine Feed-Aktivitäten.",
  back_to_previous_page: "Zurück zur vorherigen Seite",
  request_failed: "Anfrage fehlgeschlagen",
  invalid_request: "Die Anfrage ist ungültig.",
  invalid_form: "Einige Formularfelder sind ungültig.",
  invalid_form_with_fields: "Einige Formularfelder sind ungültig: {{fields}}.",
  invalid_form_field: "{{field}} {{errors}}",
  form_field_missing: "Feld ist erforderlich",
  form_field_invalid_type: "hat den falschen Typ",
  form_field_invalid_value: "hat einen ungültigen Wert",
  form_field_invalid_foreign_key: "Waehle eine gueltige Option",
  form_field_invalid_email: "Gib eine gültige E-Mail-Adresse ein",
  form_field_value_too_long: "Darf höchstens {{max}} Zeichen lang sein",
  form_field_value_too_big: "Darf höchstens {{max}} sein",
  form_field_value_too_short: "Muss mindestens {{min}} Zeichen lang sein",
  form_field_value_too_small: "Muss mindestens {{min}} sein",
  form_field_password_missing_lowercase: "Fuege einen Kleinbuchstaben hinzu",
  form_field_password_missing_uppercase: "Fuege einen Grossbuchstaben hinzu",
  form_field_password_missing_digit: "Fuege eine Zahl hinzu",
  form_field_password_missing_symbol: "Fuege ein Symbol hinzu, zum Beispiel !, @, # oder .",
  form_field_password_too_weak: "Waehle ein staerkeres Passwort",
  invalid_json: "Der Anfrageinhalt ist kein gültiges JSON.",
  invalid_websocket_upgrade: "Die Websocket-Upgrade-Anfrage ist ungültig.",
  invalid_password: "Das Passwort erfüllt die Sicherheitsanforderungen nicht.",
  invalid_path_parameter: "Der URL-Parameter {{parameter}} ist ungültig.",
  invalid_query_parameter: "Der Abfrageparameter {{parameter}} ist ungültig.",
  unsupported_value: "Der Wert für {{field}} wird nicht unterstützt.",
  permission_denied_reason: {
    generic: "Du hast keine Berechtigung für diese Aktion.",
    missing_recording_permission:
      "Platonic benötigt die Berechtigung {{permission}} für die Aufzeichnung.",
    admin_required: "Nur Administratoren können diese Aktion ausführen.",
    manage_users_required: "Du hast keine Berechtigung, Benutzer zu verwalten.",
    create_users_required: "Du hast keine Berechtigung, Benutzer zu erstellen.",
    manage_vocabulary_required:
      "Du hast keine Berechtigung, das Unternehmensvokabular zu verwalten.",
    manage_prompts_required: "Du hast keine Berechtigung, Prompts zu konfigurieren.",
    own_recording_required: "Du kannst nur deine eigenen Aufzeichnungen bearbeiten.",
    recording_delete_forbidden: "Du kannst diese Aufzeichnung nicht löschen.",
    recording_owner_access_forbidden:
      "Mit deinen Berechtigungen kannst du nicht auf Aufzeichnungen dieses Benutzers zugreifen.",
    analysis_diagnostics_forbidden: "Du hast keine Berechtigung, Analysediagnosen anzuzeigen.",
    analysis_runs_forbidden:
      "Du hast keine Berechtigung, mit den Analyseläufen dieser Aufzeichnung zu arbeiten.",
    reanalyze_recording_forbidden:
      "Du hast keine Berechtigung, eine bereits analysierte Aufzeichnung erneut zu analysieren.",
    recording_screenshot_forbidden:
      "Du kannst nicht auf Screenshots dieser Aufzeichnung zugreifen.",
    sync_model_id_forbidden: "Du kannst kein {{model}} mit dieser ID erstellen.",
    sync_model_read_only: "Unternehmens- und Benutzer-Sync-Modelle sind schreibgeschützt.",
    release_proxy_repo_forbidden:
      "Du kannst nicht auf ein anderes Repository als platonic-research/clank-core zugreifen.",
  },
  too_many_requests: "Zu viele Anfragen. {{details}}",
  conflict: "Die Anfrage steht im Konflikt mit dem aktuellen Zustand.",
  analysis_already_running:
    "Diese Aufzeichnung wird bereits analysiert. Warte, bis die laufende Analyse fertig ist, oder brich sie ab, bevor du eine neue startest.",
  service_temporarily_unavailable: "Der Dienst ist vorübergehend nicht verfügbar.",
  answer_too_long:
    "Die Antwort war zu lang, um zugestellt zu werden. Bitte stellen Sie eine engere Frage.",
  unexpected_error: "Ein unerwarteter Fehler ist aufgetreten.",
  resource_not_found: "{{resource}} nicht gefunden{{lookup}}.",
  resource_conflict: "{{resource}} existiert bereits{{lookup}}.",
  api_error_lookup_by_field: " für {{field}} {{value}}",
  api_error_lookup_by_fields: " für {{fields}}",
  api_error_lookup_unspecified: "",
  resource_kind_user: "Benutzer",
  resource_kind_company: "Unternehmen",
  resource_kind_alert: "Alert",
  resource_kind_recording: "Sitzung",
  resource_kind_recording_command: "Sitzungsbefehl",
  resource_kind_recording_event_log: "Sitzungs-Ereignislog",
  resource_kind_recording_os_permission: "Aufnahmeberechtigung",
  resource_kind_process: "Prozess",
  resource_kind_process_instance: "Fall",
  resource_kind_workflow: "Workflow",
  resource_kind_workflow_version: "Workflow-Version",
  resource_kind_ran_workflow: "Workflow-Ausführung",
  resource_kind_oidc_provider: "OIDC-Anbieter",
  resource_kind_sync_model: "Sync-Modell",
  resource_kind_vocabulary_entry: "Vokabulareintrag",
  resource_kind_prompt_snippet: "Prompt-Snippet",
  resource_kind_prompt_slot: "Prompt-Abschnitt",
  resource_kind_object: "Objekt",
  resource_kind_classification_category: "Kategorie",
  back: "Zurück",
  failed_to_load_process: "Prozess konnte nicht geladen werden",
  process_detail: "Prozessdetails",
  observed: "beobachtet",
  total_duration: "Gesamtdauer",
  steps_per_instance_full: "Durchschnittliche Schritte pro Fall",
  also_seen_as: "Auch gesehen als",
  chat: "Chat",
  ask: "Fragen",
  step_details: "Schrittdetails",
  transition_details: "Übergangsdetails",
  node_hover_hint: "Prozessschritt: für Details klicken",
  process_graph_label: "Prozessgraph",
  browse_all_processes: "Alle Prozesse durchsuchen",
  sort_processes: "Prozesse sortieren",
  feedback: {
    title: "Feedback teilen",
    description:
      "Dein Feedback geht direkt an das Platonic-Team. Der Kontext dieser Seite wird automatisch mitgesendet.",
    message_label: "Dein Feedback",
    message_placeholder:
      "Was wolltest du gerade tun?\nWas war unklar, langsam oder überraschend?\nWas hätte es besser gemacht?",
    take_screenshot: "Screenshot aufnehmen",
    taking_screenshot: "Screenshot wird aufgenommen...",
    attach_image: "Bild anhängen",
    drop_image: "Bild zum Anhängen hier ablegen",
    remove_screenshot: "Screenshot entfernen",
    screenshot_alt: "Angehängter Screenshot",
    submit: "Feedback senden",
    sent_title: "Danke für dein Feedback",
    sent_description: "Dein Feedback wurde an das Platonic-Team gesendet.",
  },
  process_directory: {
    favourites_hint: "Nur mit einem Stern markierte Prozesse.",
    feedback_title: "Fehlt ein Prozess oder stimmt etwas nicht?",
    feedback_hint: "Dein Feedback hilft, Platonic genauer zu machen.",
    feedback_action: "Feedback teilen",

    subtitle_team:
      "Entdecke die Arbeit deines Teams. Öffne einen Prozess, um seinen Ablauf zu sehen.",
    subtitle_personal: "Entdecke deine Arbeit. Öffne einen Prozess, um seinen Ablauf zu sehen.",
    group_frequency: "Häufigkeit",
    bucket_favourites: "Favoriten",
    bucket_not_favourites: "Andere Prozesse",
    group_intensity: "Zeitintensität",
    bucket_frequent: "Häufig ({{minimum}}+)",
    bucket_occasional: "Gelegentlich (bis zu {{maximum}})",
    bucket_long: "Zeitintensiv",
    bucket_short: "Weniger zeitintensiv",
    long_hint: "Durchschnittliche Dauer pro Fall von mindestens einer Stunde.",
    short_hint: "Durchschnittliche Dauer pro Fall unter einer Stunde.",
    group_by: "Gruppieren nach",
    group_none: "Keine",
    group_domain: "Geschäftsbereich",
    group_pattern: "Prozessmuster",
    bucket_unclassified: "Nicht klassifiziert",
    unclassified_hint: "Analysiert, bevor Prozesse klassifiziert wurden.",
    unknown_category: "Unbekannte Kategorie",
    group_person: "Person",
    group_application: "Anwendung",
    unknown_application: "Anwendung nicht verfügbar",
    time_unavailable: "Zeit nicht verfügbar",
    time_in_app: "Zeit in der App",
    time_in_app_hint:
      "In dieser App verbrachte Zeit während des Prozesses und ihr Anteil an der Gesamtzeit des Prozesses.",
    share_of_team: "Anteil am Team",
    share_of_team_hint: "Anteil dieser Person an der gesamten Teamzeit für den Prozess.",
    share_of_team_detail: "{{duration}} von {{total}} des Teams",
    time_in_app_detail: "{{duration}} in {{app}}, von insgesamt {{total}}",
    group_app_duration: "{{duration}} in {{app}}",
    from_grouping: "Aus Gruppierung",
    hidden_by_person_grouping: "Bei Gruppierung nach Person ausgeblendet",
    clear_filters: "Filter löschen",
    sort_within_groups: "In Gruppen sortieren",
    sort_by: "Sortieren nach",
    sort_recent: "Zuletzt beobachtet",
    sort_shared: "Am meisten geteilt",
    process: "Prozess",
    people: "Personen",
    case_count: "Fallanzahl",
    tools: "Apps",
    instances: "Fälle",
    avg_duration: "Ø Dauer",
    total_time: "Gesamtzeit",
    last_observed: "Zuletzt beobachtet",
    placeholder_description: "Prozessbeschreibung folgt.",
    placeholder_hint: "Vorläufige Beschreibung",
    unknown_person: "Unbekannte Person",
    unavailable: "Nicht verfügbar",
    open_process: "{{name}} öffnen",
    open: "Prozess öffnen",
    group_count_one: "{{count}} Prozess",
    group_count_other: "{{count}} Prozesse",
    group_total_duration: "{{duration}} insgesamt",
    directory_count: "{{groups}} Prozessgruppen · {{count}} Prozesse",
    show_more: "{{count}} weitere anzeigen",
    show_less: "Weniger anzeigen",
    total_time_hint:
      "Kumulierte beobachtete Zeit aller Fälle; gleichzeitige Arbeit kann sich überschneiden.",
    median_duration: "Mediane Dauer",
    avg_steps: "Ø Schritte",
    display: "Ansicht",
    columns: "Spalten",
    reset_display: "Auf Standard zurücksetzen",
    display_customized: "Angepasst",
  },
  process_sort_frequency: "Am häufigsten",
  process_sort_name: "Name (A–Z)",
  process_sort_duration: "Längste durchschnittliche Dauer",
  switch_process: "Prozess wechseln",
  zoom_in: "Vergrößern",
  zoom_out: "Verkleinern",
  search_steps: "Schritte durchsuchen",
  previous_search_match: "Vorheriger Treffer",
  next_search_match: "Nächster Treffer",
  no_search_matches: "0/0",
  close_search: "Suche schließen",
  set_zoom_percentage: "Zoom-Prozentsatz festlegen",
  view_controls: "Ansichtssteuerung",
  app: "App",
  times: "Mal",
  process_instance_n: "Fall {{num}}",
  scope_instance_count: "{{selected}} von {{total}} Fällen",
  process_more_actions: "Weitere Aktionen",
  process_watch: "Beobachten",
  show_process_details: "Prozessdetails anzeigen",
  hide_process_details: "Prozessdetails ausblenden",
  compare_runs: "Fälle vergleichen",
  compare_run_a: "Fall A",
  compare_run_b: "Fall B",
  compare_choose_run: "Fall auswählen…",
  compare_runs_help: "Wähle zwei Fälle aus der aktuellen Auswahl.",
  compare: "Vergleichen",
  exit_compare: "Vergleich beenden",
  watch_this_process: "Diesen Prozess beobachten",
  comparing: "Vergleich",
  compare_with: "Vergleichen mit",
  switch_instance: "Fall wechseln",
  instances_in_scope: "Fälle im Bereich",
  compare_pick_side: "Vergleichen mit",
  compare_swap_sides: "Seiten tauschen",
  compare_metric: "Kennzahl",
  compare_delta: "Δ",
  compare_total_duration: "Dauer",
  compare_total_duration_help: "Dauer erklärt",
  compare_total_duration_help_text:
    "Nur die aktive Zeit, die in den Schritten verbracht wurde. Die Wartezeiten zwischen den Schritten zählen nicht mit.",
  compare_waiting_time: "Wartezeiten zwischen Schritten",
  compare_waiting_time_help: "Wartezeiten zwischen Schritten erklärt",
  compare_waiting_time_help_text:
    "Die Summe der erfassten Lücken zwischen dem Ende eines Schritts und dem Beginn des nächsten.",
  compare_steps: "Schritte",
  compare_rework: "Wiederholte Schritte",
  compare_step_flow: "Schritt für Schritt",
  compare_shared_steps: "{{count}} gemeinsame Schritte",
  compare_shared_steps_one: "{{count}} gemeinsamer Schritt",
  compare_focus_step: "{{step}} anzeigen",
  compare_step_skipped: "In diesem Fall nicht vorhanden",
  compare_show_step_detail: "Zeigen, was {{label}} hier getan hat",
  compare_hide_step_detail: "Ausblenden, was {{label}} hier getan hat",
  graph_settings: "Graph-Einstellungen",
  advanced: "Erweitert",
  color: "Farbe",
  color_by: "Färben nach",
  color_none: "Keine",
  color_time: "Dauer",
  step_reading: "Auf Schritten zeigen",
  step_reading_help:
    "Automatisch zeigt die Fälle, solange Häufigkeit an ist, und sonst die Ausführungen mit der durchschnittlichen Dauer.",
  step_reading_auto: "Automatisch",
  step_reading_visits_avg: "Ausführungen · Ø Dauer",
  step_reading_total_time: "Gesamtdauer",
  step_reading_cases: "Fälle",
  step_reading_none: "Nichts",
  edge_routing: "Verbindungen",
  edge_routing_bundled: "Gebündelt",
  edge_routing_separate: "Getrennt",
  edge_routing_help:
    "Gebündelt führt Pfeile, die sich einen Schritt teilen, in einem Strang zusammen, der sich dort aufteilt, wo die Abläufe auseinandergehen.",
  traffic: "Häufigkeit",
  traffic_help:
    "Zeichnet jede Verbindung umso dicker, je öfter Fälle sie genommen haben, und markiert die längsten Wartezeiten. Standardmäßig aus.",
  traffic_off: "Aus",
  traffic_on: "An",
  reset_view: "Ansicht zurücksetzen",
  fit_to_screen: "An Bildschirm anpassen",
  time_share: "Zeitanteil",
  time_share_matching_instances_help: "Informationen zum Zeitanteil",
  time_share_matching_instances_tooltip:
    "Anteil der Zeit, die in Fällen, in denen dieser Schritt vorkommt, für ihn aufgewendet wird.",
  decision_step: "Entscheidungsschritt",
  app_usage: "App-Nutzung",
  step_next_steps: "Nächste Schritte",
  transition: "Übergang",
  transitions: "Übergänge",
  focus_transition: "Übergang von {{from}} zu {{to}} fokussieren",
  edge_departures_label: "Abgänge",
  edge_departures_help: "Über Abgänge",
  edge_departures_tooltip: "Anteil der Abgänge vom Quellschritt, die diesem Übergang gefolgt sind.",
  edge_average_wait_label: "Ø Wartezeit",
  edge_average_wait_help: "Über die durchschnittliche Wartezeit",
  edge_average_wait_tooltip:
    "Durchschnittliche Zeit zwischen dem Ende des Quellschritts und dem Beginn des folgenden Schritts.",
  branches: "Verzweigungen",
  n_cases: "{{count}} Fälle",
  n_cases_one: "{{count}} Fall",
  ask_why: "Nach Grund fragen",
  ask_why_time_sink: "Fragen, warum {{step}} so viel Zeit benötigt",
  ask_why_waiting_time: "Fragen, warum zwischen {{from}} und {{to}} gewartet wird",
  ask_why_transition: "Fragen, warum {{from}} zu {{to}} übergeht",
  ask_why_duration_variability: "Fragen, warum die Prozessdauern so stark variieren",
  ask_branching_prompt:
    "Warum verzweigt sich „{{name}}“ in diese verschiedenen nächsten Schritte, und welche Faktoren bestimmen den eingeschlagenen Pfad?",
  ask_transition_prompt: "Warum geht „{{from}}“ in {{percentage}} % der Fälle zu „{{to}}“ über?",
  ask_time_sink_prompt:
    "Warum entfallen {{percentage}} % der Prozesszeit auf „{{name}}“, und wofür wird die Zeit innerhalb dieses Schritts aufgewendet?",
  ask_waiting_time_prompt:
    "Dieser Übergang trat {{count}}-mal auf und hat eine durchschnittlich erfasste Wartezeit von {{duration}}. Entstanden die Wartezeiten zwischen „{{from}}“ und „{{to}}“ durch nicht zusammenhängende Aktivitäten oder durch vorbereitende Arbeit, die für den Beginn des nächsten Schritts erforderlich war? Vergleiche die längsten Wartezeiten mit typischen Fällen und identifiziere die Bedingungen, die sie verursachen.",
  ask_waiting_time_single_prompt:
    "Dieser Übergang trat einmal auf, mit einer erfassten Wartezeit von {{duration}}. Entstand die Wartezeit von {{duration}} zwischen „{{from}}“ und „{{to}}“ durch eine nicht zusammenhängende Aktivität oder durch vorbereitende Arbeit, die für den Beginn des nächsten Schritts erforderlich war?",
  ask_duration_variability_prompt:
    "Warum unterscheiden sich die Fälle von „{{name}}“ so stark in ihrer Dauer? Vergleiche die am längsten laufenden Fälle mit typischen Fällen, identifiziere die Schritte oder Bedingungen, die den Unterschied verursachen, und erkläre, wo die zusätzliche Zeit anfällt.",
  ask_about_instance: "Zu diesem Fall fragen",
  ask_why_compare_metric: "Fragen, warum sich {{metric}} zwischen {{a}} und {{b}} unterscheidet",
  ask_compare_count_metric_prompt:
    "Ich vergleiche zwei Fälle von „{{process}}“: {{a}} und {{b}}. Bei {{metric}} zeigt {{a}} {{aValue}} und {{b}} zeigt {{bValue}} ({{delta}} für {{b}}). Worauf ist dieser Unterschied zurückzuführen — welche Bedingungen in den beiden Fällen erklären ihn?",
  ask_compare_metric_prompt:
    "Ich vergleiche zwei Fälle von „{{process}}“: {{a}} und {{b}}. Bei {{metric}} zeigt {{a}} {{aValue}} und {{b}} zeigt {{bValue}} ({{delta}} für {{b}}). Worauf ist dieser Unterschied zurückzuführen — welche Schritte oder Bedingungen in den beiden Fällen erklären ihn?",
  ask_about: "Nachfragen",
  ask_instance_prompt:
    "Führe mich Schritt für Schritt durch das, was in „{{name}}“ passiert ist, und weise auf alles Ungewöhnliche oder Genauer-zu-Betrachtende hin.",
  duration_analytics: "Daueranalyse",
  duration_distribution: "Dauer-Histogramm",
  median: "Median",
  trend_over_time: "Verlauf über Zeit",
  start: "Start",
  end: "Ende",
  duration: "Dauer",
  duration_avg: "Dauer (Durchschnitt)",
  traces_begin_here: "Spuren beginnen hier",
  traces_end_here: "Spuren enden hier",
  occurrences: "Vorkommen",
  step_occurrence: "Schrittvorkommen",
  occurrence_position: "{{current}}/{{total}}",
  occurrence_position_accessible: "Vorkommen {{current}} von {{total}}",
  previous_occurrence: "Vorheriges Vorkommen",
  next_occurrence: "Nächstes Vorkommen",
  step_position_long: "Schritt {{current}} von {{total}}",
  step_position_compact: "Schritt {{current}}/{{total}}",
  step_position_start: "Start",
  step_position_end: "Ende",
  instance_view: "Falldetails",
  open_occurrence_instance_hint: "Fall bei diesem Vorkommen öffnen ({{label}})",
  instances_through_step_title: "Fälle mit diesem Schritt",
  instances_through_transition_title: "Fälle mit diesem Übergang",
  open_instance_view_hint: "Falldetails für {{label}} öffnen",
  view_instance_action: "Ansehen",
  back_to_overview: "Zurück zur Prozessübersicht",
  back_to_step_details: "Zurück zu den Schrittdetails",
  back_to_transition_details: "Zurück zu den Übergangsdetails",
  instance_steps_chronological: "Fallschritte in chronologischer Reihenfolge",
  instance_step_keys_hint: "Durch die Schritte navigieren",
  instance_step_keys_hint_sides: "Fall wechseln",
  instance_step_keys_hint_enter: "Details ansehen",
  instance_wait_gap: "{{duration}} Wartezeit",
  instance_wait_gap_between: "Wartezeit von {{duration}} zwischen „{{from}}“ und „{{to}}“",
  ask_why_waiting_time_gap:
    "Fragen, warum es eine Wartezeit von {{duration}} von {{from}} zu {{to}} gibt",
  open_instance_recording: "Sitzung von {{instance}} öffnen",
  objects: "Objekte",
  screenshots: "Screenshots",
  no_description: "Keine Beschreibung für dieses Vorkommen.",
  no_objects: "Keine Objekte für dieses Vorkommen.",
  expand_section: "{{section}} erweitern",
  collapse_section: "{{section}} einklappen",
  show_more: "Mehr anzeigen",
  show_less: "Weniger anzeigen",
  time_allocation: "Zeitverteilung",
  by_process: "nach Prozess",
  by_app: "nach App",
  other_apps: "Andere Apps",
  idle: "Nicht am Computer / Mapping pausiert",
  process_breakdown: "Prozessaufschlüsselung",
  filter_by_app: "Nach App filtern",
  all_apps: "Alle Apps",
  add_app: "App hinzufügen",
  remove_app_filter: "Filter {{app}} entfernen",
  showing_n_of_m_processes: "{{shown}} von {{count}} Prozessen",
  showing_n_of_m_processes_one: "{{shown}} von {{count}} Prozess",
  instances_of_total: "{{shown}} von {{count}} Fällen",
  instances_of_total_one: "{{shown}} von {{count}} Fall",
  n_instances: "{{count}} Fälle",
  n_instances_one: "{{count}} Fall",
  n_processes: "{{count}} Prozesse",
  n_processes_one: "{{count}} Prozess",
  percent_in_app: "{{pct}}% in {{app}}",
  no_instances_use_app: "Kein Fall verwendet {{app}}.",
  no_meaningful_process_was_found: "Kein relevanter Prozess gefunden.",
  irrelevant_processes: "Unstrukturierte Aktivität",
  session_timeline: "Sitzungs-Zeitachse",
  events_per_process_trace: "Schritte pro Prozessspur",
  process_trace: "Prozessspur",
  events: "Schritte",
  avg_length: "Durchschnittslänge",
  discovered_processes: "Erkannte Prozesse",
  processes_across_your_recordings: "{{count}} Prozesse in analysierten Sitzungen",
  processes_across_your_recordings_one: "{{count}} Prozess in analysierten Sitzungen",
  failed_to_load_processes: "Prozesse konnten nicht geladen werden",
  add_process_to_favourites: "{{name}} zu den Favoriten hinzufügen",
  remove_process_from_favourites: "{{name}} aus den Favoriten entfernen",
  add_to_favourites: "Zu Favoriten hinzufügen",
  remove_from_favourites: "Aus Favoriten entfernen",
  favourites: "Favoriten",
  no_processes_discovered_yet_record_some_sessions_first:
    "Noch keine Prozesse erkannt. Bilde zuerst etwas Arbeit ab.",
  recorded: "abgebildet",
  useless: "nutzlos",
  update_required: "Update erforderlich",
  platonic_is_ready_to_install: "Platonic {{version}} ist zur Installation bereit",
  the_update_has_already_been_downloaded_installation_must_be_completed_before_continuing:
    "Das Update wurde bereits heruntergeladen. Die Installation muss abgeschlossen werden, bevor du fortfährst.",
  release_notes: "Versionshinweise",
  install_update_now: "Update jetzt installieren",
  stop_recording_and_install_update: "Mapping beenden und Update installieren",
  page_not_found: "Seite nicht gefunden",
  no_results_for: "Keine Ergebnisse für",
  connection_to_ws_lost: "Verbindung zum WS verloren",
  already_trying_to_reconnect_please_wait:
    "Es wird bereits versucht, die Verbindung wiederherzustellen. Bitte warten.",
  app_loading_redirect_soon: "Die App wird noch geladen, du wirst gleich weitergeleitet...",
  arguments: "Argumente",
  details: "Details",
  description: "Beschreibung",
  executive_dashboard_description: "Werkzeuge zur Verwaltung von Benutzern und Sitzungen.",
  user_management: "Benutzerverwaltung",
  manage_users_description: "Benutzer anzeigen und neue Konten erstellen.",
  user_management_description:
    "Unternehmensbenutzer prüfen und einen neuen Benutzer mit Standardrechten anlegen.",
  users: "Benutzer",
  companies: "Unternehmen",
  loading_users: "Benutzer werden geladen...",
  company: "Unternehmen",
  loading_companies: "Unternehmen werden geladen...",
  companies_count: "{{count}} Unternehmen",
  users_count: "{{count}} Benutzer",
  create_company: "Unternehmen erstellen",
  create_company_description: "Ein Unternehmen erstellen, dem Benutzer zugewiesen werden koennen.",
  creating_company: "Unternehmen wird erstellt...",
  company_created: "Unternehmen erstellt.",
  company_id: "Unternehmens-ID",
  company_name: "Unternehmensname",
  company_logo_url: "Logo-URL",
  allow_password_login: "Passwort-Login erlauben",
  allow_password_login_description:
    "Benutzer dieses Unternehmens koennen sich mit Benutzername und Passwort anmelden.",
  create_user: "Benutzer erstellen",
  create_user_description: "Einen neuen Unternehmensbenutzer anlegen.",
  creating_user: "Benutzer wird erstellt...",
  enroll_user: "Benutzer einladen",
  enroll_user_description: "Einen Benutzer erstellen und eine Einladungs-E-Mail senden.",
  enrolling_user: "Benutzer wird eingeladen...",
  user_enrollment_sent: "Einladungs-E-Mail gesendet.",
  send_enrollment_email: "Einladungs-E-Mail senden",
  send_enrollment_email_to_user: "Einladungs-E-Mail an {{username}} senden",
  send_enrollment_email_confirmation: "Die Einladungs-E-Mail wird an {{email}} gesendet.",
  enrollment_resets_password_warning: "Dadurch wird das Passwort des Benutzers zurueckgesetzt.",
  enrollment_onboarding_email_warning:
    "Dadurch wird dieselbe Onboarding-E-Mail wie fuer einen neuen Benutzer gesendet.",
  enrollment_existing_missing_email:
    "Dieser Benutzer hat keine E-Mail-Adresse, daher kann keine Einladungs-E-Mail gesendet werden.",
  impersonate_user: "Benutzer impersonieren",
  impersonate_user_help:
    "Erstellt eine Browser-Sitzung als anderer Benutzer. Dadurch wird deine aktuelle Sitzung in diesem Browser ersetzt.",
  select_user_to_impersonate: "Benutzer zum Impersonieren auswählen",
  start_impersonation: "Impersonation starten",
  username: "Benutzername",
  password: "Passwort",
  email: "E-Mail",
  first_name: "Vorname",
  last_name: "Nachname",
  name: "Name",
  actions: "Aktionen",
  edit_company: "Unternehmen bearbeiten",
  save_company: "Unternehmen speichern",
  password_login_enabled: "Aktiviert",
  password_login_disabled: "Deaktiviert",
  edit_user: "Benutzer bearbeiten",
  save_user: "Benutzer speichern",
  manage_user_permissions: "Berechtigungen verwalten",
  user_permissions: "Benutzerberechtigungen",
  user_permissions_description: "Zugriffsregeln dieses Benutzers prüfen und aktualisieren.",
  save_user_permissions: "Berechtigungen speichern",
  permissions_updated: "Berechtigungen aktualisiert.",
  back_to_user_management: "Zurück zur Benutzerverwaltung",
  failed_to_load_user_permissions: "Benutzerberechtigungen konnten nicht geladen werden",
  failed_to_update_user_permissions: "Benutzerberechtigungen konnten nicht aktualisiert werden",
  selected_user_not_found: "Ausgewählter Benutzer nicht gefunden",
  simplified_permission_form: "Vereinfachtes Berechtigungsformular",
  admin_user: "Admin-Benutzer",
  recordings_permissions: "Sitzungsberechtigungen",
  processes_permissions: "Prozessberechtigungen",
  screenshots_permissions: "Screenshot-Berechtigungen",
  users_permissions: "Benutzerberechtigungen",
  can_create_users: "Kann Benutzer erstellen",
  permission_scope: "Umfang",
  permission_only_mine: "Nur eigene",
  permission_all_company: "Ganzes Unternehmen",
  permission_specific_users: "Bestimmte Benutzer",
  permission_all: "Alle Benutzer",
  specific_users: "Bestimmte Benutzer",
  new_password_optional: "Neues Passwort (optional)",
  confirm_password: "Passwort bestätigen",
  back_to_executive_dashboard: "Zurück zur Verwaltung",
  failed_to_load_users: "Benutzer konnten nicht geladen werden",
  failed_to_load_companies: "Unternehmen konnten nicht geladen werden",
  failed_to_create_user: "Benutzer konnte nicht erstellt werden",
  failed_to_enroll_user: "Benutzer konnte nicht eingeladen werden",
  failed_to_update_user: "Benutzer konnte nicht aktualisiert werden",
  failed_to_update_company: "Unternehmen konnte nicht aktualisiert werden",
  passwords_do_not_match: "Die Passwörter stimmen nicht überein.",
  you_do_not_have_permission_to_create_users: "Du hast keine Berechtigung, Benutzer zu erstellen.",
  you_do_not_have_permission_to_create_companies:
    "Du hast keine Berechtigung, Unternehmen zu erstellen.",
  you_do_not_have_permission_to_edit_companies:
    "Du hast keine Berechtigung, Unternehmen zu bearbeiten.",
  you_do_not_have_permission_to_edit_users: "Du hast keine Berechtigung, Benutzer zu bearbeiten.",
  show_n_screenshots: "{{count}} Screenshots anzeigen",
  show_n_screenshots_one: "{{count}} Screenshot anzeigen",
  failed_to_load_screenshot: "Screenshot konnte nicht geladen werden",
  screenshot_n_of_total: "Screenshot {{current}} von {{total}}",
  previous_screenshot: "Vorheriger Screenshot",
  next_screenshot: "Nächster Screenshot",
  play_screenshot_autoplay: "Screenshots abspielen",
  pause_screenshot_autoplay: "Screenshots pausieren",
  screenshot_playback_speed: "Wiedergabegeschwindigkeit",
  start_at_stage: "Ab Stufe starten",
  use_lift_tools: "LLM-Tools verwenden",
  filters: "Filter",
  search_people: "Personen suchen…",
  people_you: "{{name}} (Du)",
  people_only_you: "Nur du",
  search_in_processes: "In Prozessen suchen…",
  search_recordings: "Nach Name suchen…",
  from: "Von",
  to: "Bis",
  min: "Min",
  max: "Max",
  step_count: "Schrittanzahl",
  repetitions: "Wiederholungen",
  clear_all_filters: "Alle Filter löschen",
  no_results_match_filters: "Keine Ergebnisse stimmen mit den Filtern überein.",
  showing_n_of_total: "{{filtered}} von {{total}} angezeigt",
  chat_back_to_details: "Zurück zu den Details",
  chat_close_sidebar: "Seitenleiste schließen",
  chat_across_sessions: "Sitzungsübergreifend fragen",
  sessions_scope: "Sitzungsbereich",
  my_sessions: "Meine Sitzungen",
  team_sessions: "Teamsitzungen",
  sessions_navigator: "Sitzungsnavigation",
  sessions_latest: "Neueste Sitzung",
  sessions_view: "Sitzungsansicht",
  sessions_empty_scope: "Keine Sitzungen in dieser Ansicht. Versuche Aktiv, Archiviert oder Alle.",
  sessions_timeline_group: "{{count}} Sitzungen",
  sessions_timeline_reset: "7 Tage um die ausgewählte Sitzung anzeigen",
  sessions_timeline_days: "{{count}} Tage",
  sessions_timeline_days_one: "{{count}} Tag",
  sessions_timeline_help: "Scrollen zum Blättern · Strg + Scrollen zum Zoomen",
  sessions_empty_personal: "Deine Sitzungen erscheinen hier, sobald du deine Arbeit aufzeichnest.",
  sessions_previous: "Vorherige Sitzung",
  sessions_next: "Nächste Sitzung",
  sessions_session: "Sitzung",
  sessions_date_time: "Datum und Uhrzeit",
  sessions_analysis: "Analyse",
  sessions_analysis_ready: "Bereit",
  sessions_not_analyzed: "Nicht analysiert",
  chat_this_session: "Diese Sitzung",
  chat_alert_paused: "Benachrichtigung pausiert",
  chat_pause_alert: "Benachrichtigung pausieren",
  chat_resume_alert: "Benachrichtigung fortsetzen",
  chat_manage_alert: "Benachrichtigung bearbeiten",
  chat_alert_update_failed:
    "Die Benachrichtigung konnte nicht aktualisiert werden. Bitte erneut versuchen.",
  chat_history_empty: "Noch keine Unterhaltungen.",
  chat_recent: "Verlauf",
  chat_expand: "Gespräch vergrößern",
  chat_collapse: "Zurück zur Seitenleiste",
  chat_following_page: "Folgt der Seite",
  chat_custom_context: "Eigener Kontext",
  chat_use_session: "Diese Sitzung verwenden",
  chat_use_runs: "Diese Fälle verwenden",
  chat_selected_runs: "{{count}} ausgewählte Fälle",
  chat_change_selection: "Auswahl ändern",
  chat_session_processes: "Alle Prozesse dieser Sitzung",
  chat_panel_modes: "Prozessbereich",
  chat_details: "Details",
  chat_ask_result: "Nachfrage stellen",
  chat_ask_result_hint: "Vertiefe dieses Ergebnis in Ask, mit dem Bericht als Kontext.",
  chat_alert_result: "Meldungsergebnis",
  chat_result_data: "Gespeichertes Ergebnis. Die Filter unten wählen Daten für Folgefragen aus.",
  chat_result_scope_unknown:
    "Ursprüngliche Datenauswahl nicht verfügbar: Die Filter verwenden die aktuellen Meldungseinstellungen zum Ergebnisdatum.",
  chat_alert_example_duration: "Melde mir, wenn die durchschnittliche Falldauer steigt.",
  chat_alert_example_manual: "Fasse die Zeit für manuelle Dateneingabe zusammen.",
  chat_alert_example_rework: "Zeige Schritte, die häufiger wiederholt werden.",
  chat_follow_page: "Seitenauswahl verwenden",
  chat_change_context: "Ändern",
  chat_custom_context_help:
    "Oder Personen, Prozesse und einen Zeitraum für die nächsten Fragen wählen. Dies ersetzt die Seitenauswahl.",
  chat_apply_context: "Diesen Kontext verwenden",
  chat_kpi_scope_help:
    "Wähle aus, was du verfolgen möchtest, und beantworte eventuelle Rückfragen. Dein KPI wird automatisch erstellt und kann unter Insights bearbeitet werden.",
  chat_kpi_process_help:
    "Die Benachrichtigung prüft alle Fälle des gewählten Prozesses. Einzelne Schritte und Fälle werden nicht als Filter übernommen.",
  chat_kpi_session_help:
    "Die Benachrichtigung prüft neue Sitzungen. Wähle die Personen und den Zeitraum aus.",
  chat_kpi_creating: "KPI wird erstellt…",
  chat_kpi_retry: "KPI erneut erstellen",
  chat_kpi_review_failed: "Dein KPI konnte nicht vorbereitet werden. Bitte versuche es erneut.",
  chat_kpi_saved: "KPI erstellt",
  chat_kpi_saved_help: "Du kannst diesen KPI jederzeit unter Insights bearbeiten.",
  chat_kpi_view: "KPI ansehen",
  chat_back_to_conversation: "Unterhaltung",
  chat_track_this: "Als KPI verfolgen",
  chat_track_this_hint:
    "Stelle diese Frage regelmäßig neu und verfolge, wie sich die Antwort ändert.",
  chat_track_this_dismiss: "KPI-Vorschlag ausblenden",
  chat_opens_sidebar: "Öffnet Ask in der Seitenleiste",
  chat_new_question: "Neues Gespräch",
  chat_scope_label: "Fragen zu",
  chat_scope_changed: "Bereich geändert zu: {{label}}",
  chat_selected_steps: "Ausgewählte Schritte",
  chat_remove_selected_step: "{{step}} aus dem Chat-Kontext entfernen",
  chat_ask_tooltip:
    "Diese Filter gelten für deine nächste Frage. Der Kontext bleibt beim Wechsel auf eine andere Seite erhalten.",
  chat_ephemeral_warning: "Dieser Chat ist temporär und geht beim Neustart der App verloren.",
  chat_getting_long:
    "Diese Unterhaltung wird lang. Beginnen Sie eine neue, damit die Antworten schnell bleiben.",
  chat_too_long:
    "Diese Unterhaltung ist zu lang, um fortzufahren. Beginnen Sie eine neue, um weiterzufragen.",
  chat_too_many_messages:
    "Diese Unterhaltung hat ihr Nachrichtenlimit erreicht. Beginnen Sie eine neue, um weiterzufragen.",
  chat_input_mentions_placeholder: "Frage zu diesen Daten… @ für Kontext eingeben",
  chat_input_placeholder: "Frage zu diesen Daten stellen…",
  chat_ai_disclaimer:
    "Antworten werden von einer KI generiert und können Fehler enthalten. Überprüfen Sie wichtige Informationen.",
  chat_send: "Senden",
  chat_stop: "Stopp",
  chat_copy: "Kopieren",
  chat_copied: "Kopiert",
  chat_quote_in_reply: "In Antwort zitieren",
  chat_error_generic: "Der Assistent konnte nicht antworten. Bitte erneut versuchen.",
  chat_static_demo_unavailable: "Diese Funktion ist nur in der echten Platonic-Version verfügbar.",
  chat_dismiss_error: "Schließen",
  chat_thinking_analyzing_process_context: "Prozesskontext wird analysiert...",
  chat_thinking_listing_recordings: "Sitzungen werden aufgelistet...",
  chat_thinking_reading_recording_metadata: "Sitzungsmetadaten werden gelesen...",
  chat_thinking_reading_process_instances: "Fälle werden gelesen...",
  chat_thinking_inspecting_analysis_details: "Analysedetails werden geprüft...",
  chat_thinking_searching_in_nodes: "Analyseknoten werden durchsucht...",
  chat_thinking_computing_node_metrics: "Kennzahlen werden berechnet...",
  chat_thinking_analyzing_screenshots: "Screenshots werden analysiert...",
  chat_thinking_running_subagents: "Subagents werden ausgeführt...",
  chat_thinking_reasoning: "Denke nach...",
  chat_thinking_preparing_final_answer:
    "Antwort wird mit den bereits gesammelten Informationen vorbereitet...",
  chat_suggestion_time_sink: "Was ist der größte Zeitfresser?",
  chat_suggestion_differences: "Wo unterscheiden sich die Fälle am stärksten?",
  chat_suggestion_summary: "Fasse diesen Prozess für ein neues Teammitglied zusammen.",
  chat_with_recording: "Mit Sitzung chatten",
  chat_new_conversation: "Chat leeren und neu beginnen",
  chat_suggestion_recording_time: "Wo ist die Zeit in dieser Sitzung geblieben?",
  chat_suggestion_recording_summary: "Fasse zusammen, was in dieser Sitzung gemacht wurde.",
  chat_suggestion_recording_unstructured: "Was geschah außerhalb der Hauptprozesse?",
  vocabulary: "Vokabular",
  vocabulary_page_description:
    "Die Prozess- und Schrittnamen, die die Analyse beim Beschriften von Sitzungen bevorzugt. Beiträge wirken nur auf zukünftige Analysen.",
  add_to_vocabulary: "Namen vereinheitlichen",
  vocabulary_scope_label: "Gilt für",
  vocabulary_scope_user: "Nur meine Analysen",
  vocabulary_scope_company: "Gesamtes Unternehmen",
  change_vocabulary: "Vereinheitlichte Namen bearbeiten",
  vocabulary_updating_entry: "Wird gespeichert…",
  vocabulary_names_saved: "Namen gespeichert",
  vocabulary_blank_name: "Ein Name darf nicht leer sein. Fülle ihn aus oder lass ihn weg.",
  vocabulary_no_names: "Wähle mindestens einen Schrittnamen aus, bevor du speicherst.",
  vocabulary_popover_title: "Diese Namen als Standard für künftige Sitzungen festlegen",
  vocabulary_popover_lede:
    "Wenn diese Arbeit das nächste Mal auftaucht, beschriftet die Analyse sie mit den unten ausgewählten Namen, statt neue zu erfinden. Frühere Analysen bleiben davon unberührt.",
  vocabulary_popover_help: "Wie das funktioniert",
  vocabulary_popover_process_label: "Name für diesen Prozess",
  vocabulary_popover_steps_label: "Namen für seine Schritte",
  vocabulary_saved_steps_label: "Bereits gespeicherte Namen",
  vocabulary_new_steps_label: "Neue Namen in dieser Analyse",
  vocabulary_select_all: "Alle auswählen",
  vocabulary_select_none: "Auswahl aufheben",
  vocabulary_save_names: "Diese Namen speichern",
  vocabulary_override_hint:
    "Für diesen Prozess gibt es bereits eine Definition. Speichern ersetzt sie.",
  vocabulary_scope_badge_builtin: "eingebaut",
  vocabulary_scope_badge_personal: "persönlich",
  vocabulary_overridden_definitions: "{{count}} überschriebene Definitionen",
  vocabulary_overridden_definitions_one: "{{count}} überschriebene Definition",
  vocabulary_create_override: "Überschreiben",
  vocabulary_edit_entry: "Bearbeiten",
  vocabulary_new_entry: "Neuer Eintrag",
  vocabulary_process_name: "Prozessname",
  vocabulary_steps_hint: "Schritte (einer pro Zeile)",
  vocabulary_add_entry: "Eintrag hinzufügen",
  vocabulary_adding_entry: "Wird hinzugefügt…",
  vocabulary_delete_entry: "Löschen",
  vocabulary_empty: "Noch keine Vokabulareinträge.",
  vocabulary_contributed_by_you: "du",
  vocabulary_scope_badge_company: "unternehmensweit",
  failed_to_load_vocabulary: "Vokabular konnte nicht geladen werden",
  vocabulary_categories: "Kategorien",
  vocabulary_processes: "Prozesse",
  n_categories: "{{count}} Kategorien",
  n_categories_one: "{{count}} Kategorie",
  vocabulary_categories_description:
    "Die Kategorien, in die jede Analyse Schritte und Prozesse einordnet. Archivierte bleiben für frühere Analysen erhalten, werden für neue aber nicht verwendet.",
  category_kind_step_type: "Schrittarten",
  category_kind_business_domain: "Geschäftsbereiche",
  category_kind_process_pattern: "Prozessmuster",
  category_name: "Name",
  category_description: "Beschreibung",
  category_add: "Kategorie hinzufügen",
  category_archive: "Archivieren",
  category_unarchive: "Wiederherstellen",
  category_archived_badge: "archiviert",
  category_min_active: "Jede Liste braucht mindestens {{count}} aktive Kategorien.",
  prompt_config_title: "Prompt-Konfiguration",
  prompt_config_card_description:
    "Die Prompt-Texte bearbeiten, mit denen Analysen und Chats laufen.",
  prompt_config_description:
    "Jeder Prompt besteht aus einer festen Struktur mit bearbeitbaren Abschnitten. Beim Speichern eines Abschnitts wird eine neue Version angelegt, die ab dem nächsten Lauf für das ganze Unternehmen gilt; Zurücksetzen stellt den eingebauten Text wieder her.",
  prompt_config_no_permission: "Du hast keine Berechtigung, Prompts zu konfigurieren.",
  prompt_config_customized: "angepasst",
  prompt_config_built_in: "eingebaut",
  prompt_config_snippet_name: "Versionsbezeichnung",
  prompt_config_slot_text: "Abschnittstext",
  prompt_config_company_label: "Prompts konfigurieren für",
  prompt_config_all_companies: "Alle Unternehmen (systemweite Vorgaben)",
  prompt_config_deployment_text: "systemweite Anpassung",
  prompt_config_tab_assignments: "Zuweisungen",
  prompt_config_tab_snippets: "Snippets",
  prompt_config_option_built_in: "Eingebauter Text",
  prompt_config_option_inherit: "Keine Unternehmensanpassung",
  prompt_config_new_snippet: "Neues Snippet",
  prompt_config_new_version: "Neue Version",
  prompt_config_delete_snippet_hint:
    "Diese Version und davon abgeleitete löschen; betroffene Abschnitte fallen auf den vorherigen Text zurück",
  prompt_config_show_text: "Text anzeigen",
  prompt_config_hide_text: "Text ausblenden",
  prompt_config_no_snippets: "Noch keine Snippets gespeichert.",
  prompt_config_version_label: "Version",
  prompt_config_save_and_apply: "Speichern und anwenden",
  prompt_config_apply_target: "Wird auf {{target}} angewendet",
  send: "Senden",
  pause: "Pausieren",
  resume: "Fortsetzen",
  edit: "Bearbeiten",
  delete: "Löschen",
  person: "Person",
  people: "Personen",
  weekly: "Wöchentlich",
  minutes_ago: "vor {{count}} Min.",
  hours_ago: "vor {{count}} Std.",
  days_ago: "vor {{count}} T.",
  custom_ellipsis: "Benutzerdefiniert…",
  analysis_ready_title: "{{count}} Sitzungen sind zur Analyse bereit",
  analysis_ready_title_one: "Sitzung ist zur Analyse bereit",
  analysis_ready_description:
    "Der Upload ist abgeschlossen. Analysieren Sie Ihre Sitzungen, um Prozesse und App-Nutzung zu entdecken.",
  analysis_ready_action: "Sitzungen zur Analyse ansehen",
  review_ready_title: "{{count}} Sitzungen sind zur Prüfung bereit",
  review_ready_title_one: "Sitzung ist zur Prüfung bereit",
  review_recordings_title: "Sitzungen, die auf Ihre Prüfung warten",
  review_recordings_subtitle:
    "Nichts verlässt diesen Computer, bis Sie es freigeben. Prüfen Sie die Screenshots und geben Sie die Sitzung zum Hochladen frei oder löschen Sie sie.",
  review_today: "Heute",
  review_yesterday: "Gestern",
  review_approve_all: "Alle freigeben und hochladen ({{count}})",
  review_approved: "Freigegeben. {{count}} Sitzungen werden hochgeladen…",
  review_approved_one: "Freigegeben. Ihre Sitzung wird hochgeladen…",
  review_deleted: "Sitzung gelöscht.",
  review_all_caught_up: "Alles geprüft",
  review_details: "Apps und Aktivitäten",
  review_approve_recording: "Freigeben und hochladen",
  review_screenshots: "Screenshots prüfen",
  review_screenshots_hint:
    "Screenshots ansehen und alle ausschließen, die nicht hochgeladen werden sollen",
  review_exclude_screenshot: "Ausschließen",
  review_include_screenshot: "Einschließen",
  review_n_excluded: "{{count}} ausgeschlossen",
  review_exclude_confirm_title: "{{excluded}} von {{count}} Screenshots vor dem Hochladen löschen?",
  review_exclude_confirm_title_one:
    "{{excluded}} von {{count}} Screenshot vor dem Hochladen löschen?",
  review_exclude_confirm_description:
    "Die ausgeschlossenen Screenshots werden endgültig von diesem Computer gelöscht. Der Rest der Sitzung wird hochgeladen.",
  review_upload_all_confirm_title: "Die gesamte Sitzung hochladen?",
  review_upload_all_confirm_description:
    "Keine Screenshots sind ausgeschlossen: alles, was in dieser Sitzung aufgezeichnet wurde, wird hochgeladen.",
  review_n_screenshots: "{{count}} Screenshots",
  review_n_screenshots_one: "{{count}} Screenshot",
  review_n_events: "{{count}} Ereignisse",
  review_n_events_one: "{{count}} Ereignis",
  review_n_clicks: "{{count}} Klicks",
  review_n_clicks_one: "{{count}} Klick",
  review_n_shortcuts: "{{count}} Tastenkürzel",
  review_n_typed_chars: "{{count}} Zeichen getippt",
  review_apps_heading: "Apps und Fenster",
  review_no_apps: "Keine App-Aktivität aufgezeichnet",
  review_untitled_window: "(Fenster ohne Titel)",
  review_more_window_titles: "+{{count}} weitere",
  review_more_window_titles_one: "+{{count}} weiterer",
  review_excluded_apps: "Ausgeschlossene Apps",
  review_excluded_apps_total: "{{duration}} insgesamt",
  review_excluded_apps_hint: "Während diese Apps aktiv waren, wurde nichts aufgezeichnet.",
  tour: tourGerman,
  watchlist: watchlistGerman,
} satisfies ClankTranslation;
